import type { JSONSchema7Definition } from "json-schema";

import { RanaWidget } from "./types/rana-widget";
import { FIELDS } from "./utils/fields-const";

export const getRanaWidgetFromProperty = <WidgetId extends RanaWidget["id"]>(
  property: JSONSchema7Definition,
  id?: WidgetId
): (RanaWidget & { id: WidgetId }) | undefined => {
  if (typeof property === "boolean" || !("rana_widget" in property)) return;
  const ranaWidget = property.rana_widget as RanaWidget;

  if (!FIELDS[ranaWidget.id]) {
    console.warn(ranaWidget.id + " doesn't have a supported widget");
    return;
  }

  if (id && id !== ranaWidget.id) return;
  return ranaWidget as RanaWidget & { id: WidgetId };
};
